import { NavigationLink } from "@/utils/constants";

const AGENT_ONLY_NAV_NAMES = new Set(["comingSoon"]);
const AGENT_HIDDEN_DESKTOP_NAV_NAMES = new Set(["ourTeam", "aboutUs", "contactUs"]);
const AGENT_HIDDEN_MOBILE_NAV_NAMES = new Set(["ourTeam", "aboutUs", "contactUs", "clientPortal"]);

type NavigationVariant = "desktop" | "mobile";

export const filterNavigationLinks = (
  links: NavigationLink[],
  { isSalesAgent, variant }: { isSalesAgent: boolean; variant: NavigationVariant },
): NavigationLink[] => {
  const hiddenNames = variant === "desktop" ? AGENT_HIDDEN_DESKTOP_NAV_NAMES : AGENT_HIDDEN_MOBILE_NAV_NAMES;

  return links.filter((link) => {
    if (AGENT_ONLY_NAV_NAMES.has(link.name) && !isSalesAgent) {
      return false;
    }

    if (isSalesAgent && hiddenNames.has(link.name)) {
      return false;
    }

    return true;
  });
};
